// Imports

// App Imports
import {
  ECONOMIC_INFORMATION_REQUEST,
  ECONOMIC_INFORMATION_RESPONSE,
  ECONOMIC_INFORMATION_FAILURE,
  REGISTER_ECONOMIC_INFORMATION_REQUEST,
  REGISTER_ECONOMIC_INFORMATION_RESPONSE,
  REGISTER_ECONOMIC_INFORMATION_FAILURE,
} from "./actions";

// Initial State
const elementsInitialState = {
  isLoading: false,
  error: false,
  list: [],
  created: undefined
};

// State
export const economicInformation = (state = elementsInitialState, action) => {
  switch (action.type) {
    case ECONOMIC_INFORMATION_REQUEST:
      return {
        ...state,
        isLoading: action.isLoading,
        error: false,
        created: undefined
      };

    case ECONOMIC_INFORMATION_RESPONSE:
      return {
        ...state,
        isLoading: false,
        error: false,
        economicINFORMATION: action.economicInformation,
        created: undefined
      };

    case ECONOMIC_INFORMATION_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.error,
        errorMessage: action.errorMessage,
        created: undefined
      };
    case REGISTER_ECONOMIC_INFORMATION_REQUEST:
      return {
        ...state,
        isLoading: action.isLoading,
        error: false,
        created: undefined
      }
    case REGISTER_ECONOMIC_INFORMATION_RESPONSE:
      return {
        ...state,
        isLoading: false,
        error: false,
        created: action.created
      };

    case REGISTER_ECONOMIC_INFORMATION_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.error,
        errorMessage: action.errorMessage,
        created: undefined
      }
    default:
      return state;
  }
};
